import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatListModule } from '@angular/material/list';

export interface GroupPickDialogData {
  title: string;
  message?: string;
  groups: { group_id: number; name: string }[];
}

@Component({
  selector: 'app-group-pick-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatListModule],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    @if (data.message) {
    <mat-dialog-content>
      <p>{{ data.message }}</p>
    </mat-dialog-content>
    }
    <mat-dialog-content>
      <mat-action-list>
        @for (g of data.groups; track g.group_id) {
        <button mat-list-item type="button" (click)="pick(g.group_id)">
          {{ g.name }}
        </button>
        }
      </mat-action-list>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="cancel()">Annuller</button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroupPickDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<GroupPickDialogComponent, number | null>,
    @Inject(MAT_DIALOG_DATA) public data: GroupPickDialogData
  ) {}

  pick(groupId: number): void {
    this.dialogRef.close(groupId);
  }

  cancel(): void {
    this.dialogRef.close(null);
  }
}
